import { Box, Typography } from "@mui/material";
import NeuSurface from "../components/surface/NeuSurface";
import { NeuButton } from "../components/actions/NeuButtons";
import { useCurrentUser } from "../hooks/useCurrentUser";

export default function SignInPage() {
  const { signIn } = useCurrentUser();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        px: 3,
      }}
    >
      <NeuSurface
        variant="panel"
        sx={{
          p: 5,
          width: "100%",
          maxWidth: 460,
          textAlign: "center",
        }}
      >
        <Typography variant="h3" sx={{ mb: 1 }}>
          LexOne
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Sign in to access your dashboard.
        </Typography>

        <NeuButton variant="gradientBorderLime" onClick={signIn}>
          Sign in
        </NeuButton>
      </NeuSurface>
    </Box>
  );
}